export default __webpack_public_path__ + "static/gpw-8eff74d40eca7d34b765fbd9c7aa98d5.png";